export default {"src":"/_next/static/media/pageLoader.65f9d0dc.gif","height":120,"width":120,"blurWidth":0,"blurHeight":0};